import { useDispatch } from 'react-redux';
import { actions } from '../../../../../ducks/global';

const useConnect = () => {
  const dispatch = useDispatch();

  return {
    setOptionalCookies: payload => dispatch(actions.setOptionalCookies(payload)),
  };
};

export default useConnect;
